import { DocCookies } from "../../cookies";
import { Polyglot } from "../../polyglot";

declare var __APP_BASE_URL__: string;
declare var __LOGIN_URL__: string;

const docCookies = new DocCookies();

export const saveAuthCookies = (cookies: string) => docCookies.setItem('Auth', cookies, null, '/');
export const redirectToApp = () => window.location.replace(__APP_BASE_URL__);

export const removeAutCookies = () => {
  localStorage.removeItem("selectedDivisionId")
  return docCookies.removeItem('Auth', '/');
}
export const redirectToLogin = () => window.location.replace(__LOGIN_URL__);


// WEBPACK FOOTER //
// ./src/login/commands/configure.ts